import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@core/services/translation.service';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base.component';
import { GrpserviceService } from '../../grpservice.service';

@Component({
  selector: 'app-add-edit-marker-dialog',
  templateUrl: './add-edit-marker-dialog.component.html',
  styleUrls: ['./add-edit-marker-dialog.component.scss'],
})
export class AddEditMarkerDialogComponent
  extends BaseComponent
  implements OnInit
{
  newsForm!: FormGroup;
  isEdit: boolean = false;
  newsId?: number;

  constructor(
    public dialogRef: MatDialogRef<AddEditMarkerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public translationService: TranslationService,
    private toastrService: ToastrService,
    private newsService: GrpserviceService
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.newsForm = this.fb.group({
      marqueeText: ['', [Validators.required, Validators.maxLength(5000)]],
      linkText: ['', [Validators.required, Validators.maxLength(1000)]],
    });

    // If data is passed → Edit mode
    if (this.data && this.data.marquee) {
      // ✅ fix key name
      this.isEdit = true;
      this.newsId = this.data.marquee.id;
      this.newsForm.patchValue({
        marqueeText: this.data.marquee.marqueeText, // ✅ correct mapping
        linkText: this.data.marquee.linkText, // ✅ correct mapping
      });
    }
  }

  // Getter for easy access in template
  get f() {
    return this.newsForm.controls;
  }

  onSubmit(): void {
    if (this.newsForm.valid) {
      const formData = this.newsForm.value;
      const authObj = JSON.parse(localStorage.getItem('authObj') || '{}');
      const fullName =
        authObj.firstName && authObj.lastName
          ? `${authObj.firstName} ${authObj.lastName}`
          : authObj.userName || '';

      // ✅ Match backend contract (camelCase)
      const payload: any = {
        id: this.isEdit ? this.newsId : 0,
        marqueeText: formData.marqueeText,
        linkText: formData.linkText,
        createdBy: this.isEdit ? null : fullName,
        updatedBy: this.isEdit ? fullName : null,
        approvedBy: null,
        approvedDate: null,
        approvedStatus: null,
        action: this.isEdit ? 'UPDATE' : 'INSERT',
      };

      const request$ = this.newsService.ManageMarqueeRecord(payload);

      request$.subscribe({
        next: (res) => {
          this.toastrService.success(
            this.isEdit
              ? 'Marquee updated successfully.'
              : 'Marquee added successfully.'
          );
          this.dialogRef.close(res);
        },
        error: (err) => {
          if (err.error && err.error.errors) {
            const allErrors = Object.values(err.error.errors).join('<br/>');
            this.toastrService.error(allErrors, 'Validation Error', {
              enableHtml: true,
            });
          } else {
            this.toastrService.error('Failed to save marquee.');
          }
          console.error(err);
        },
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
